export default __webpack_public_path__ + "static/media/UnderConstruction.ea6db4b6.svg";